import { useNewStrategyContext } from './NewStrategyContext';
import { Icon } from '../UI';

export const ProgressNav = () => {
  const { currentStep, flowSteps } = useNewStrategyContext();

  const availableSteps = flowSteps.filter(({ showInNavbar }) => showInNavbar);

  return (
    <div
      className={`
        grid
        grid-cols-${availableSteps.length}
        w-full
        h-full
        border-grey-10
      `}
    >
      {availableSteps.map(({ key, title }, i) => (
        <div
          key={key}
          className="w-full h-full border-l border-grey-10 dark:border-grey-70"
        >
          <div
            className={`relative flex justify-center items-center w-full h-full px-4
              ${
                i <= currentStep - 1
                  ? 'border-b-4 border-primary'
                  : 'border-b border-grey-10 dark:border-grey-80 '
              }
            `}
          >
            <span
              className={`hidden sm:inline text-xs font-semibold text-center truncate
                ${
                  i <= currentStep - 1
                    ? 'text-black dark:text-white'
                    : 'text-grey-30 dark:text-grey-70'
                }
             `}
            >
              {title}
            </span>
            <div
              className={`absolute flex items-center justify-center -bottom-3 w-5 h-5 rounded-full
                ${
                  i <= currentStep - 1
                    ? 'bg-primary'
                    : 'bg-grey-10 dark:bg-grey-80 '
                }
              `}
            >
              <Icon
                svgName={'check'}
                className={`text-sm font-extrabold p-0.5
                  ${i <= currentStep - 1 ? 'text-black' : 'text-white'}
                `}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
